


























































import { Component, Vue } from 'vue-property-decorator';
import NavDrawer from '@/components/NavDrawer.vue';
import Dialog from '@/components/Dialog.vue';
import HelpDialog from '@/components/HelpDialog.vue';
import log from 'loglevel';

@Component({
  components: {
    NavDrawer,
    Dialog,
    HelpDialog,
  },
})
export default class App extends Vue {
  public showNav: boolean | null = null;
  public about = false;
  public feedback = false;
  public notice = false;

  // These are specific to the SW update process.
  public updateExists = false;
  public refreshing = false;
  public registration: any = {};

  public created(): void {
    document.addEventListener(
      'swUpdated', this.showRefreshUI, { once: true },
    );
    navigator.serviceWorker.addEventListener(
      'controllerchange', () => {
        if (this.refreshing) {
          return;
        }
        log.info('Caught controllerchange, refreshing...');
        this.refreshing = true;
        window.location.reload();
      },
    );
  }

  private showRefreshUI(e: any) {
    log.info('Caught swUpdated, update available.');
    this.registration = e.detail;
    this.updateExists = true;
  }

  public refreshApp(): void {
    log.info('Refreshing app to update.');
    this.updateExists = false;
    if (!this.registration || !this.registration.waiting) {
      log.warn('Registration does not exist or is not waiting, bailing out of update.');
      return;
    }
    this.registration.waiting.postMessage('skipWaiting');
  }

  public mounted(): void {
    this.$store.dispatch('loadSettings').then(() => {
      this.notice = !!this.$store.state.notice;
    });
  }
}
